<template>
  <SingletonDirectusContent :title="$t('navigation.guidelines')" collection="d_guidelines_translations" />
</template>
